import { createUbiProd1Interaction, } from '@spotify-internal/event-definitions/es5/events/createUbiProd1Interaction';
import { createUbiProd1InteractionNonAuth, } from '@spotify-internal/event-definitions/es5/events/createUbiProd1InteractionNonAuth';
import { getParentPath, getParentSpecModes, getParentSpecVersions, getPathProps, } from '../utils/EventUtils';
import { EMPTY_STRING } from '../constants';
import { v4 as uuid } from 'uuid';
export const InteractionEventConverter = (function interactionFn() {
    function createGabitoEvent(event, authenticationProvider, ubiContextualProviders) {
        var _a, _b, _c, _d;
        const pathProps = getPathProps(event.location.pathNodes);
        const parentPath = getParentPath(event.parentAbsoluteLocation);
        const parentPathProps = getPathProps(parentPath);
        const parentSpecVersions = getParentSpecVersions(event.parentAbsoluteLocation);
        const parentSpecModes = getParentSpecModes(event.parentAbsoluteLocation);
        let baseEvent = {
            action_parameter_names: event.actionParameterNames,
            action_parameter_values: event.actionParameterValues,
            action_name: event.actionName,
            action_version: event.actionVersion,
            annotator_configuration_version: EMPTY_STRING,
            annotator_version: EMPTY_STRING,
            app: event.app,
            element_path_ids: pathProps.element_path_ids,
            element_path_names: pathProps.element_path_names,
            element_path_pos: pathProps.element_path_pos,
            element_path_reasons: pathProps.element_path_reasons,
            element_path_uris: pathProps.element_path_uris,
            generator_version: event.generatorVersion,
            interaction_id: uuid(),
            interaction_type: event.interactionType,
            parent_modes: parentSpecModes,
            parent_path_ids: parentPathProps.element_path_ids,
            parent_path_names: parentPathProps.element_path_names,
            parent_path_pos: parentPathProps.element_path_pos,
            parent_path_reasons: parentPathProps.element_path_reasons,
            parent_path_uris: parentPathProps.element_path_uris,
            parent_specification_versions: parentSpecVersions,
            specification_version: event.specificationVersion,
            specification_mode: event.specificationMode,
        };
        if (ubiContextualProviders.pageInstanceIdProvider) {
            baseEvent = Object.assign(Object.assign({}, baseEvent), { page_instance_id: ubiContextualProviders.pageInstanceIdProvider.getPageInstanceId() ||
                    null });
        }
        if (ubiContextualProviders.playbackIdProvider) {
            baseEvent = Object.assign(Object.assign({}, baseEvent), { playback_id: ((_a = ubiContextualProviders.playbackIdProvider) === null || _a === void 0 ? void 0 : _a.getPlaybackId()) || null });
        }
        if (ubiContextualProviders.playContextUriProvider) {
            baseEvent = Object.assign(Object.assign({}, baseEvent), { play_context_uri: ((_b = ubiContextualProviders.playContextUriProvider) === null || _b === void 0 ? void 0 : _b.getPlayContextUri()) ||
                    null });
        }
        if (ubiContextualProviders.pageUriProvider) {
            baseEvent = Object.assign(Object.assign({}, baseEvent), { page_uri: ((_c = ubiContextualProviders.pageUriProvider) === null || _c === void 0 ? void 0 : _c.getPageUri()) || null });
        }
        if (authenticationProvider.isAuthenticated()) {
            return createUbiProd1Interaction(baseEvent);
        }
        const nonAuthInteractionEvent = Object.assign(Object.assign({}, baseEvent), { flow_id: ((_d = ubiContextualProviders.flowIdProvider) === null || _d === void 0 ? void 0 : _d.getFlowId()) || null });
        return createUbiProd1InteractionNonAuth(nonAuthInteractionEvent);
    }
    return { createGabitoEvent };
})();
//# sourceMappingURL=InteractionEventConverter.js.map